import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { adminUpdateUserApi } from 'redux/actions/adminPtPlus/index';
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper } from '.././PTPlusStyled'
import TextInput from 'web/components/form-elements/TextInput';
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import EditIcon from "web/assets/svg/PtPlusUserViewEditIcon";

import AlertModal from 'web/components/AlertModal';

function Notes(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [accordionOpen, setAccordionOpen] = useState(false)
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');

    const updateApiFunction = async () => {
        let id = pageProps.pageData.id
        let url = `ptms/internal/update_notes/${id}`
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let data = {
            note: fieldValues.notes,
        }
        const token = localStorage.getItem('token')
        response = await dispatch(adminUpdateUserApi(url, data, token))
        if (response.success) {
            setAlertModalContent('Detail has been updated successfully.')
            setAlertModal(!alertModal)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }
    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
        window.location.reload(false);
    }
    const resetFieldsFunction = () => {
        const initailData = pageProps.pageData
        pageProps.setFieldValue('notes', initailData.notes || '')
    }

    return (
        <>
            <Container>
                <AccordionHeader>
                    <h6 onClick={() => {
                        if(accordionOpen) setAccordionOpen(false)
                        else setAccordionOpen(true)
                    }}>Notes</h6>
                    {accordionOpen ?
                        <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
                        : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
                    }
                </AccordionHeader>
                {accordionOpen &&
                    <AccordionBody>
                        <InputFieldsWrapper>
                            <div className="row">
                                <div className="col-md-12">
                                    <TextInput name='notes' placeholder={`Notes`} maxLength={200} />
                                </div>
                            </div>
                        </InputFieldsWrapper>
                        <div className='view-edit-button-section'>
                            <button className='save-button' onClick={() => updateApiFunction()}><EditIcon />Update</button>
                            <button className='cancel-button' onClick={() => resetFieldsFunction()}>Cancel</button>
                        </div>
                    </AccordionBody>
                }
            </Container>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )
}

export default Notes
